const cancel = 'إلغاء'
const save = 'حفظ'

export default {

  global: {
    generalError: 'يا للحظ! لم تتم معالجة طلبكم من فضلك، قم بإعادة تحميل الصفحة ',
    signature: 'مع أطيب التحيات، ',
  },

  component: {
    actionBar: {
      actions: 'إجراءات',
      hideActions: 'قم بإخفاء الإجراءات',
      next: 'Next',
      previous: 'Previous',
    },

    addButton: {
      add: 'أضف ',
    },

    aiSummaryBox: {
      transcript: 'Transcript',
      summary: 'Summary',
    },

    attachments: {
      add: 'أضف السيرة الذاتية أو مرفقات أخرى مطلوبة',
      placeholderWithDescription: 'أضف المرفقات المطلوبة',
      remove: 'إحذف',
      allowedFileTypes: 'أنواع الملفات المسموح بها',
      errors: {
        size: 'الملف كبير جدًا، الحد الأقصى لحجم الملف هو 5 ميغابايت',
        empty: 'لا يحتوي الملف على أي بيانات ',
        invalidType: fileType => `عذرًا، نوع الملف هذا غير مسموح به لأسباب أمنية: ${fileType}`,
        typeNotWhitelisted: 'عذرًا، نوع الملف غير مسموح به.',
      },
    },

    agreeTos: {
      privacyLinkText: 'سياسة الخصوصية',
      termsLinkText: 'الشروط والأحكام',
      privacyPolicyText: 'نحن نقدر خصوصيتك، يرجى الإطلاع على سياسة الخصوصية',
      termsText1: 'المرجو الإطلاع على وقبول سياسة الخصوصية',
      termsText2: 'قبل تزويدنا ببياناتك الشخصية.',
      privacyLink: 'https://get.recright.com/privacy-policy',
      termsLink: 'https://get.recright.com/recright-terms-and-conditions-candidate',
      privacyInfo: mail => `إذا كنت لا تريد في أن نقوم بمعالجة بياناتك الشخصية، يمكنك طلب إزالتها عن طريق إرسال رسالة إلينا عبر البريد الالكتروني التالي: ${mail}.`,
      customSupportPrivacyInfo: link => `إذا كنت لا تريد في أن نقوم بمعالجة بياناتك الشخصية، يمكنك طلب إزالتها عن طريق رابط الاتصال التالي: ${link}.`,
    },

    buttons: {
      close: 'إغلاق',
    },

    competencies: {
      addCompetency: 'أضف كفاءة جديدة',
      edit: 'تعديل الكفاءات',
      done: 'تم',
      defaultsDescription: 'إذا كنت غير متأكد من الكفاءات التي يجب اختيارها، فقد حددنا بعض الخيارات  الجيدة لمساعدتك على البدء.',
      getDefaults: 'إستخدم الخيارات الموصى بها.',
    },

    competency: {
      warning: 'هل تريد إزالة الكفاءة وجميع تقييماتها؟',
    },

    confirmDelete: {
      delete: 'حذف',
      cancel: 'إلغاء',
      confirm: 'تأكيد',
    },

    confirm: {
      cancel: 'الرجوع للحالة السابقة',
      confirm: 'كرر مجددا',
    },

    confirmButton: {
      wait: count => `انتظر ${count}`,
      confirm: 'تأكيد',
    },

    controlStatus: {
      text: {
        empty: 'إملأ الإستمارة',
        valid: () => 'مستعد',
      },
      textarea: {
        empty: 'إملأ الإستمارة',
        valid: (length, limit) => `${length}/${limit}`,
      },
      select: {
        empty: 'إنهاء',
        valid: () => 'مستعد',
      },
      file: {
        empty: 'إختر',
        valid: () => 'غير',
      },
      list: {
        empty: 'أضف',
        valid: (length, limit) => `${length}/${limit}`,
      },
      search: {
        empty: 'إبحث',
        valid: () => 'مستعد',
      },
    },

    emailAddresses: {
      candidateNamePlaceholder: 'Candidate name',
      remove: 'إحذف',
      importCsv: 'استيراد ملف CSV',
      invalidEmails: 'تم العثور على برد إلكترونية غير صحيحة. ',
      maxCsvEntryErrorNotification: amount =>
        `Max ${amount} csv entries allowed`,
      importCsvTooltip:
        'The csv rows can have email or email,phone. Each row represents a recipient. The phone numbers needs to be in international format (E.164) e.g. (<strong>+358</strong>50xxxxxxx).',
    },

    emailDeliveryStatus: {
      Undetermined: {
        Undetermined: 'رسالة إلكترونية مرتدة تحقق من أن المستلم قد تلقى رسالتك.',
      },
      Permanent: {
        General: 'رسالة بريد إلكتروني غير قابلة للتسليم تم رفض الرسالة من طرف مقدم خدمة البريد الإلكتروني للمستلم للرسالة.',
        NoEmail: 'الإيميل غير موجود.',
        Suppressed: 'لم يتم تسليم رسائل البريد الإلكتروني بسبب محاولات التسليم الفاشلة السابقة.',
      },
      Transient: {
        General: 'رسالة إلكترونية مرتدة تحقق من أن المستلم قد تلقى رسالتك.',
        MailboxFull: 'صندوق رسائل المتلقي ممتلئ.',
        MessageTooLarge: '[حجم] محتوى رسالة البريد الإلكتروني كبير جدًا.',
        ContentRejected: 'تم رفض حجم محتوى رسالة البريد الإلكتروني',
        AttachmentRejected: 'تم رفض المرفق',
      },
    },

    smsDeliveryStatus: {
      notDelivered: 'تمت إضافة رسالة SMS إلى قائمة الإنتظار، وهي في انتظار تسليمها.',
      failed: 'فشل في إرسال رسالة SMS.',
      duplicate: 'لقد تم ارفاق الرقم المعطى مسبقا للمترشح لهذه المقابلة.',
    },

    error403: {
      heading: 'ممنوع الولوج',
      content: 'المرجو  التحقق من أن  تسجيل الدخول تم في الحساب الصحيح، وأنه تمت دعوتك لمراجعة هذه الوظيفة في منصة Recright. وتحقق ايضا من أنك تستعمل منصة Recright في نافذة بمتصفح واحد.',
      link: 'الصفحة الرئيسية.',
    },

    error404: {
      heading: 'صفحة فارغة',
      content: 'قمنا بالبحث بشكل مكثف، ولكن لا توجد صفحة الويب للعنوان الذي قمت بطلبه.  فربما قمت بإتباع رابطًا منتهي الصلاحية أو كتبت عنوانًا خاطئًا عن طريق الخطأ.',
      link: 'الصفحة الرئيسية.',
    },

    error410: {
      heading: 'مغلق',
      content: 'لا يمكن عرض الوظيفة لأنها إما مغلقة أو انتهت فترة طلب العمل.',
      link: 'الصفحة الرئيسية.',
    },

    calendarError: {
      heading: 'فشل ربط الإتصال بجدول زمنك.',
      content: 'لم نتمكن من ربط الإتصال بجدولك الزمني.  المرجو إعادة المحاولة  لاحقًا، وإذا استمرت المشكلة، فيرجى الاتصال بفريق الدعم لدينا.',
    },

    flash: {
      starting: 'التهيئة جارية ...',
      connection_error_hint: 'تعذر الإتصال بشبكة الانترنت جرب إعادة تحميل الصفحة.',
      permission_hint: 'يجب عليك منح هذا الموقع الإذن باستعمال كاميرا الويب والميكروفون الخاصين بك.',
      searching_camera_hint: 'البحث جار عن كاميرا الويب...',
      camera_reserved_hint: 'قام تطبيق أو صفحة ويب أخرى باستخدام كاميرا الويب الخاصة بك. المرجو إغلاق هذا التطبيق وأعد تحميل هذه الصفحة.',
      camera_reserved_hint_chrome_extra: 'عزيزي مستعمل Chrome، يجب أن تسمح لمنصة Recright باستعمال كاميرا الويب من خانة التنبيه التي تظهر أسفل شريط العناوين.',
      no_camera_hint: 'تعذر العثور على كاميرا الويب.',
      no_mic_hint: 'تعذر العثور على المايكرفون.',
      uploading_text: 'جارٍ التحميل...',
      rtmpt_in_use: 'لن تكون هذه الخطوة ضرورية اذا كان مسؤول الشبكة لديك يسمح باستخدام RTMP.  استفسر عن الكيفية.',
      preview_text: 'كاميرا الويب في قيد وضع المعاينة',
      close_text: 'أغلق تشغيل الكاميرا.',
      remove_text: 'الرجوع للحالة السابقة',
      noflash_errortext_install: link => `It looks like you don't have Adobe Flash Player. You need a flash plugin to record videos. Get flash here: ${link}`,
      noflash_errortext_enable: link => `If you have already installed flash, but you still see this message. Look here: ${link}`,
      noflash_errortext_differentbrowser: 'وكبديل لذلك، يمكنك تجربة متصفح يدعم تسجيل HTML5. نقترح عليك استخدام Chrome أو Firefox.',
    },

    footer: {
      terms: 'شروط وأحكام المستخدم.',
      license: 'الشروط العامة للخدمة',
      privacyPolicy: 'سياسة الخصوصية',
      customSupport: link => `رابط التواصل ${link}`,
      accessibilityReport: 'إمكانية الوصول إلى التقرير.',
    },

    feedbackPulse: {
      howWouldYouRateInterview: 'ما تقييمك لتجربتك في المقابلة؟',
      howWouldYouRateJobAd: 'ما تقييمك لتجربتك في طلب العمل؟',
      yourResponseIsAnonymous: 'لن يتم ذكر إسمك كمجيب.',
      thankYouFeedback: 'شكرا لك على ملاحظاتك!',
    },

    candidateFooter: {
      termsLink: 'https://get.recright.com/recright-terms-and-conditions-candidate',
      privacyPolicyLink: 'https://get.recright.com/privacy-policy',
      accessibilityReportLink: 'https://websitemedia.recright.com/wp-content/uploads/2024/11/06112306/accessibility_report.pdf',
    },

    cookieConsentModal: {
      title: 'يستخدم موقعنا ملفات تعريف الإرتباط (الكوكيز).',
      body: 'عند موافقتك على جميع ملفات تعريف الارتباط، فإنك توافق على تخزينها على جهازك لتحسين تصفح الموقع، وتحليل استخدام الموقع، ودعم جهودنا التسويقية.',
      learnMoreLinkText: 'تعرف على المزيد حول كيفية استخدامنا لملفات تعريف الارتباط',
      learnMoreLink: 'https://get.recright.com/cookies/',
      manageCookies: 'إدارة ملفات تعريف الارتباط',
      acceptAll: 'قبول كافة ملفات تعريف الارتباط',
      manageTitle: 'إدارة تفضيلات الموافقة',
      necessaryCookiesTitle: 'ملفات تعريف الارتباط الأساسية',
      necessaryCookiesBody:
        'تعد ملفات تعريف الارتباط هذه أساسية  لتشغيل الموقع ولا يمكن تعطيلها في أنظمتنا.',
      performanceCookiesTitle: 'ملفات تعريف الارتباط الخاصة بالأداء',
      performanceCookiesBody:
        'تسمح لنا هذه الملفات بتتبع عدد الزيارات ومصادر حركة المرور لنتمكن من قياس وتحسين أداء موقعنا.',
      marketingCookiesTitle: 'ملفات تعريف الارتباط التسويقية',
      marketingCookiesBody:
        'تمكننا هذه الملفات من تخصيص الإعلانات وقياس أدائها.',
      functionalCookiesTitle: 'ملفات تعريف الارتباط الوظيفية',
      functionalCookiesBody:
        'تُستخدم هذه  الملفات لتحسين وظائف عمل الموقع. بدون ملفات تعريف الارتباط هذه، قد لا تكون بعض الوظائف متاحة. من أمثلة ملفات تعريف الارتباط الوظيفية: خدمات الدردشة على الويب وتفضيلات المستخدم.',
      confirmChoices: 'تأكيد اختياراتي',
    },

    formErrors: {
      typeNotWhitelisted: 'عذرًا، نوع الملف غير مسموح به.',
      isRequired: 'هذا الحقل إلزامي.',
      invalidUrl: 'عنوان URL غير صحيح.',
      isEmail: value => `${value} ليس بريدًا إلكترونيًا صالحًا.`,
      isDate: value => `${value} ليس تاريخًا صالحًا.`,
      singleHireEndError: 'لا يمكن أن يكون  التعيين الفردي صالحا لأكثر من 60 يومًا.',
      isNotTooOldForLive: 'إنتهى تاريخ طلب الوظيفة.',
      isNotAfterEndDate: 'لا يمكن أن يكون التاريخ الذي يتم اختياره بعد تاريخ إنتهاء الإعلان عن الوظيفة.',
      isValidMobilePhone: value => `${value ? `${value}` : ''} رقم الهاتف غير صحيح`,
      isInternationalPhoneNumber: 'يجب أن يكون رقم الهاتف بالصيغة الدولية.',
      duplicateNumber: 'تمت إضافة رقم الهاتف مسبقا.',
      duplicateCompetency: 'هذا الاسم مسجل كشخص كفء لهذه المهارة المطلوبة',
      isNotDuplicateTemplateName: 'هذا الإسم مسجل له استمارته .',
    },

    jobAdApplication: {
      name: 'الإسم',
      city: 'مسقط الرأس',
      email: 'البريد الإلكتروني',
      phone: 'رقم الهاتف',
      applyForPosition: 'التقدم لطلب وظيفة',
      back: 'الرجوع',
      continue: 'استمر',
      submit: 'أرسل',
      saveForLater: 'استمر لاحقا',
      namePlaceholder: 'سجل إسمك',
      emailPlaceholder: 'سجل بريدك الإلكتروني',
      phonePlaceholder: 'أدخل رقم هاتفك',
      cityPlaceholder: 'أدخل مسقط رأسك الحالي',
      links: 'أضف روابط، على سبيل المثال ملفك الشخصي على LinkedIn',
      legendBasicInfo: 'معلومات اساسية',
      legendLinks: 'روابط',
      legendAttachments: 'مرفقات',
      legendAdditionalFields: 'معلومات إضافية',
      coverLetter: 'الرسالة الوظيفية',
      attachments: 'مرفقات',
      introduction: 'اكتب مقدمتك الوجيزة هنا',
      thankYou: 'شكرًا لك.',
      luck: 'حظا سعيدا!',
      close: 'إغلاق',
      required: 'تعتبر العناصر التي تحمل علامة النجمة * إلزامية الجواب.',
    },

    jobAdContainer: {
      endTime: date => (date ? `التسجيل مفتوح إلى غاية ${date}` : ''),
    },

    jobAdDetails: {
      apply: 'تقدم إلى وظيفة',
    },

    jobAdQuickInterview: {
      back: 'الرجوع',
      submit: 'أرسل',
      saveForLater: 'استمر لاحقا',
      title: 'مقابلة قصيرة عبر الفيديو',
      description: 'لنتعرف عليك بسرعة أكبر، نطلب منك الإجابة باختصار على سؤال المقابلة القصيرة. أضف لمستك الشخصية لطلبك.',
      requiredNote: 'يرجى ملاحظة أن هذة خطوة واحدة فقط في عملية التقديم، ولن يتمكن مسؤول التوظيف من رؤية طلبك إلا بعد تسجيل إجابتك.',
      reminderNote: 'يمكنك تسجيل إجابتك على الفور، أو يمكنك العودة لاحقا  لتسجيلها بعد تلقي تذكير عبر بريدك الإلكتروني.',
    },

    jobAdRow: {
      responses: 'طلبات العمل',
      status: {
        open: 'إفتح',
        filled: 'معبأ',
        cancelled: 'ملغى',
        done: 'تم',
        close: 'إغلاق',
        draft: 'مغلق (مسودة)',
        hidden: 'مخفي',
      },
    },

    interviewRow: {
      responses: 'المترشحين',
    },

    linkedInProfile: {
      showLinkedInProfileModal: 'قم بعرض LinkedIn باعتباره ملفا شخصيا',
    },

    linkedInButton: {
      error: 'حدث خطأ أثناء الإطلاع على الملف الشخصي. يرجى المحاولة مجددا.',
      buttonText: 'تقدم بطلبك عبر LinkedIn',
    },

    linkedInContainer: {
      linkedInButtonDescription: 'يمكنك استخدام ملفك الشخصي LinkedIn لملء نموذج الطلب تلقائيا.',
      linkedInOr: 'أو',
      error: 'حدث خطأ أثناء الإطلاع على الملف الشخصي. يرجى المحاولة مجددا.',
    },

    linkListInput: {
      addField: 'أضف',
      removeField: 'إحذف',
      invalidUrl: 'عنوان URL غير صحيح.',
    },

    liveRoom: {
      greeting: name => `Hello, ${name}.`,
      notYetStarted: startTime =>
        `The interview has not yet started. The interview starts at ${startTime}.`,
      interviewTitle: title => `Interview title: ${title}`,
      interviewStartsIn: timeLeft => `The Interview starts in: ${timeLeft}`,
      interviewHasEnded: 'The interview has ended.',
      youHaveLeft: 'You have left the interview.',
      rejoinInterview: 'Rejoin interview',
      joinInterview: 'Join interview',
      goToEvaluations: 'Continue to evaluation',
      structuredInterview: {
        timeEstimateText: timeEstimate => `${timeEstimate} minutes`,
        guideNotesPlaceHolder: stepTitle => `Notes for ${stepTitle}`,
        goToNextStepButtonText: 'Go to next section',
        totalTime: 'Total time in interview:',
        timeIn: partName => `Time in ${partName}:`,
        nextStep: stepTitle => `Next up: ${stepTitle}`,
      },
    },

    loadingButton: {
      loading: 'جار التحميل ...',
      saving: 'جار الحفظ ...',
      sending: 'جار الإرسال ...',
    },

    modalApplicationForm: {
      applyForPosition: 'التقدم لطلب وظيفة',
      continue: 'استمر',
      name: 'سجل إسمك',
      email: 'سجل بريدك الإلكتروني',
      phoneNumber: 'أدخل رقم هاتفك',
      links: 'يمكنك إضافة روابط',
      legendLinks: 'روابط',
      legendAttachments: 'مرفقات',
      coverLetter: 'الرسالة الوظيفية',
      attachments: 'مرفقات',
      introduction: 'اكتب مقدمتك الوجيزة هنا',
      thankYou: 'شكرًا لك.',
      luck: 'حظا سعيدا!',
      close: 'إغلاق',
    },

    modalConfirm: {
      cancel,
      confirm: 'حسنا',
    },

    modalAlert: {
      close: 'إغلاق',
    },

    modalLinkShare: {
      title: 'رابط عام قابل للمشاركة',
      info: 'إليك عنوان الرابط العام الذي يمكنك مشاركته بخصوص إعلان عن وظيفة. يمكن لأي شخص مهتم بالوظيفة الإطلاع على إعلان الوظيفة ثم يتخذ قرار تقديم الطلب. ستتلقى الإشعار المعهود عند بداية وصول الطلبات. إليك عنوان الرابط العام لإعلان الوظيفة:',
    },

    modalVideoAdd: {
      chooseTitle: 'أضف فيديو جديد',
      title: 'سجل فيديو جديد',
      titlePlaceholder: 'أدخل عنوان الفيديو هنا',
      cancel,
      save,
    },

    modalVideoUpload: {
      title: 'قم برفع فيديو جديد',
      info: 'الحد الأقصى لحجم الفيديو المسموح به هو 500 ميجابايت. نوصي بتقليل حجم الفيديوهات قبل الرفع، بحيث  سيساهم ذلك في تقليل وقت تحويل صيغ الفيديو ورفعها.',
    },

    modalCandidateInfo: [
      {
        headline: 'سجل ردك عبر الفيديو.',
        content: 'لعدة مرات وكما يحلو لك.  سيتم حفظ مقاطع الفيديو مباشرة بعد التسجيل، ويمكنك العودة إلى مقابلة الفيديو عبر الرابط المرسل إلى بريدك الإلكتروني.',
        mobileContent: 'لعدة مرات وكما يحلو لك.  أضف الفيديو إلى المقابلة. ستتمكن من مشاهدة الفيديو الذي تم رفعه وحفظه في المقابلة. يمكنك العودة إلى المقابلة المصورة بالفيديو عبر الرابط الذي وصلك إلى بريدك الإلكتروني. <br><br><strong>إذا بقيت شاشة الفيديو سوداء وكنت تستخدم جهاز Apple، يمكنك العثور على إرشادات لحل المشكلة. <a style="text-decoration: underline;" target="_blank" rel="noopener noreferrer" href="https://support.recright.com/en/articles/11187-recording-doesn-t-work-with-ipad-iphone">here</a>.</strong>',
      },
      {
        headline: 'بعد تصوير المقابلة',
        content: 'تأكد من تشغيل الفيديو بشكل صحيح وأن صوتك مسموع.  عندما تضغط على زر الإرسال، سيتم قفل إجابتك ولن تتمكن من تعديلها بعد ذلك.',
      },
      {
        headline: 'عندما الإنتهاء من المقابلة،',
        content: '"اضغط على زر إرسال الإجابات لإكمال المقابلة  بعد ذلك لن تتمكن من الرجوع إلى مقابلة الفيديو. إذا كنت ترغب في إغلاق هذه الصفحة ومتابعة المقابلة لاحقًا، اضغط على زر ""المتابعة لاحقًا"""',
      },
      {
        headline: 'إذا كنت بحاجة إلى مساعدة ',
        content: mailto => `إذا كنت بحاجة إلى مساعدة في إجراء المقابلة ، انقر على زر المساعدة في الزاوية السفلية اليمنى من الصفحة أو أرسل لنا رسالة عبر البريد الالكتروني ${mailto}`,
        customContent: link => `رابط التواصل ${link}`,
      },
    ],

    navigationBar: {
      back: 'الرجوع',
      dashboard: 'لوحة التحكم.',
      frontpage: 'الصفحة الرئيسية.',
    },

    personDetails: {
      stage: 'منصة',
      namePlaceholder: 'مُرَشَّح(ة)',
      contact: 'تواصل معنا',
      links: 'روابط',
      attachments: 'مرفقات',
      coverLetter: 'الرسالة الوظيفية',
      referrer: 'مصدر المحيل',
      referrerInfo: 'الموقع الإلكتروني الذي جاء منه المرشح للخدمة.',
      noStage: 'قيد الإنتظار.',
      lastSeen: time => `آخر ظهور ${time}.`,
      headerAdditionalInformation: 'معلومات إضافية',
      state: {
        invited: 'مدعو',
        visited: 'تم الإطلاع',
        incomplete: 'غير مكتمل',
        completed: 'مكتمل',
      },
      notVisited: 'لم أطلع على المقابلة بعد.',
      scheduledInterview: 'معلومات المقابلة',
      scheduledInterviewInvitationSent: 'مدعو إلى مقابلة',
      scheduledInterviewInvitationExpired: 'انتهت صلاحية الدعوة',
      scheduledInterviewInvitationEventCreated: '',
      scheduledInterviewReScheduleMeeting: 'إعادة جدولة المقابلة',
      otherPersons: count => `تظهر هذه المشكلة أيضا في إعلانات وظائف أخرى: ${count}`,
    },

    phoneInput: {
      placeholder: example => `أدخل رقم الهاتف وفقا للصيغة التالية: ${example}`,
    },

    questionsAndResponses: {
      response: 'إجابة',
      noResponse: 'لا توجد إجابة',
      resetQuestionResponse: 'احذف جواب المترشح',
      resetQuestionResponseConfirm: questionTitle =>
        `""${questionTitle}"": هل أنت متأكد من أنك تريد إعادة خاصية تكرار الإجابة لهذا السؤال للمرشح وحذف إجابته السابقة؟`,
      resetQuestionResponseConfirm2: 'إذا قمت بذلك، يمكن للمرشح إعادة الإجابة على هذا السؤال.',
      aiInsights: 'AI Insights',
      showQuestion: 'Show question video',
      hideQuestion: 'Hide question video',
      question: 'Question',
      nonAnswerableInfo: 'Question is non-answerable.',
      evaluationCriteriaLabel: 'Evaluation criteria',
    },

    rating: {
      ownVote: 'تقييمك',
      yourVotePlaceholder: 'لم تقم بالتصويت بعد.',
      totalVotes: count => `إجمالي التقييمات: ${count}`,
      noRatings: 'لا يوجد أي تقييم',
      mobileModalHeader: 'أضف تقييمك',
      yourRatingReset: 'إعادة ضبط تصويتك',
      averageRating: 'متوسط التقييم',
      reset: 'إعادة ضبط',
    },

    share: {
      share: 'شارك الرابط',
      copy: 'نسخ الرابط',
    },

    sort: {
      sort: 'رتب',
    },

    supportLink: 'support@recright.com',

    typeSelect: {
      selected: 'تم اختيارك',
      change: 'غير',
    },

    video: {
      videoNotFound: 'تتم عملية معالجة الفيديو أو لم يتم العثور عليه .',
      retry: 'كرر مجددا ',
      originalLanguageLabel: 'النص الأصلي',
      englishLanguageLabel: 'الإنجليزية',
    },

    videoUpload: {
      uploadPlaceholder: isMobile => (isMobile ? 'قم برفع أو تسجيل فيديو جديد' : 'حدد الملف'),
      videoPlaceholder: 'سجل جوابك',
      uploadPlaceholderCandidate: 'إرسال جوابك',
      submit: 'إبعث الجواب',
      notAnswered: 'لم نتلقى إجابتك بعد',
      remove: 'الرجوع للحالة السابقة',
      converting: 'الفيديو في طور المعالجة يرجى الإنتظار ...',
      uploading: 'الفيديو في طور الإرسال يرجى الإنتظار ...',
      error: {
        invalid: 'الملف المحدد كبير للغاية.  الرجاء اختيار ملف آخر.',
        upload: 'لم نتمكن من رفع الفيديو، نعتذر عن ذلك.  يرجى المحاولة مجددا.',
        transcode: 'فيديو الملف الذي اخترته إما تالف أو غير مدعوم، يرجى المحاولة مرة أخرى.',
      },
    },

    virtualBg: {
      showMoreButtonText: 'أظهر المزيد',
      showLessButtonText: 'عرض عدد أقل',
      infoText1:
        'حافظ على تفعيل علامة التبويب في الواجهة أثناء عملية التسجيل.  تجنب إستخدام أي تطبيق أخر خلال فترة التسجيل.',
      infoText2:
        'تعمل مقاطع الفيديو الخلفية بكفاءة أعلى على أحدث المتصفحات ومع الأجهزة الحديثة وعالية الأداء.',
      infoText3:
        'تأكد من أن التطبيقات الأخرى لا تستخدم الميكروفون أو الكاميرا خاصتك.',
    },

    videoResponse: {
      videoPlaceholder: 'سجل جوابك',
      uploadPlaceholder: 'قم برفع جوابك',
      submit: 'إبعث الجواب',
      notAnswered: 'لم نتلقى إجابتك بعد',
      required: 'هذا السؤال يتطلب جواباً',
      startInterview: 'ابدأ المقابلة',
    },

    webcam: {
      useVideoBgButtonText: 'إضافة خلفية مرئية للفيديو',
      removeVideoBgButtonText: 'إزالة الخلفية من الفيديو',
      starting: 'في طور البدء ...',
      close: 'أغلق تشغيل الكاميرا.',
      remove: 'حذف الجواب',
      record: 'سجل',
      stop: 'توقف',
      retake: 'إعادة المحاولة',
      submit: 'إبعث الجواب',
      converting: 'الفيديو في طور المعالجة يرجى الإنتظار ...',
      uploading: 'الفيديو في طور الإرسال يرجى الإنتظار ...',
      downloading: 'الفيديو في طور التحميل.  يرجى الإنتظار ...',
      processing: 'في طور المعالجة ...',
      uploadInProgress: 'لا تزال عملية نقل الفيديو جارية، يرجى عدم إغلاق  المتصفح أو تغيير الصفحة.',
      uploaded: 'تم إتمام عملية نقل الفيديو.',
      error: {
        DevicesNotFoundError: 'لا يمكن  استخدام الكاميرا أو الميكروفون. يرجى التأكد من السماح لهم بذلك',
        NotFoundError: 'لا يمكن  استخدام الكاميرا أو الميكروفون. يرجى التأكد من السماح لهم بذلك',
        NotAllowedError: 'تم رفض الوصول إلى الكاميرا أو الميكروفون من قبلك.',
        PermissionDismissedError: 'قمت بإيقاف مربع الحوار المرجو السماح باستخدام الكاميرا والميكروفون.',
        PermissionDeniedError: 'تم رفض الوصول إلى الكاميرا أو الميكروفون من طرفك .',
        NotReadableError: 'النظام غير مسموح له للوصول إلى بيانات الكاميرا أو الميكروفون. هناك احتمالية وجود عطل في الأجهزة.',
        SecurityError: 'لا يمكن استخدام الكاميرا أو الميكروفون بسبب عطل أمني.',
        stream: 'حدث خطأ. الرجاء إعادة تشغيل المتصفح. إذا استمرت المشكلة، يرجى المحاولة باستخدام متصفح آخر.',
        download: 'حدث فشل في تحميل الفيديو. هل تريد المحاولة مجددا؟',
        upload: 'حدث فشل في رفع الفيديو. هل تريد المحاولة مجددا؟',
        emptyBlob: 'ذاكرة المتصفح أو الجهاز لديك ممتلئة ولا يمكن القيام بالتسجيل. يرجى تحديث الصفحة وإذا لم يحل ذلك المشكلة، يرجى إعادة تشغيل المتصفح. إذا استمرت المشكلة، يرجى المحاولة باستخدام متصفح آخر.',
        alternativeRecorder: 'يمكنك أيضًا تحميل الملف بالنقر على هذا الرابط.',
        reconnecting: 'تمت مقاطعة الإتصال .  جارٍ محاولة إعادة الاتصال.',
      },
    },

    smsMessages: {
      invitationMessage: title =>
        `مرحبًا! نرغب في دعوتك إلى حضور مقابلة عبر الفيديو ${title}! تم إرسال هذه الدعوة أيضًا إلى بريدك الإلكتروني.`,
    },
  },
  page: {
    interviewPreview: {
      info: 'This is a preview of the interview. Video recording is disabled and the form data is not saved.',
    },
  },
}
